import mutations from "@/store/modules/space/mutations";
import getters from "@/store/modules/space/getters";
import actions from "@/store/modules/space/actions";

const state = {
  space: null,
  selectedSpaceCustomize: null,
  spacesAvailable: [],
  superSpace: {},
  usersInSpace: [],
  usersInDraw: [],
  totalUsersInSpace: 0,
  allUsers: [],
  sceneTypes: [],

  usersInSpacePage: 1,
  lastPage: 2,

  spacesAvailablePage: 1,
  lastPageSpaces: 2,

  favouriteSpaces: [],

  connectedSuperSpaceIds: [],
  connectedUsersCounter: 0,
};
export type State = typeof state;

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
